export const routes = {
  RELEASE_NOTES_ROUTE: '/release-notes',
}
